import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeskIcon(props: IconProps) {
    return <Icon {...props} iconKey={"desk"}/>
}
